<template>
  <v-container>
    <h1 class="text-h5 mb-6">Secciones del Sitio</h1>
    <v-row dense>
      <v-col
        v-for="section in sections"
        :key="section.name"
        cols="12"
        sm="6"
        md="4"
      >
        <v-card 
          class="mx-auto"
          max-width="400"
          outlined
          hover 
      :to="section.route"
        >
          <v-img :src="section.image" height="160px" cover />
          <v-card-title class="d-flex align-center">
            <!-- <v-icon class="mr-2">{{ section.icon }}</v-icon> -->
            {{ section.title }}
          </v-card-title>
          <v-card-text>{{ section.description }}</v-card-text>
          <!-- <v-card-actions>
            <v-btn :to="section.route" color="primary" variant="flat">Ir a sección</v-btn>
          </v-card-actions> -->
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
const sections = [
  {
    name: 'gallery',
    title: 'Galería',
    description: 'Explora todas las imágenes organizadas por tipo de evento y estilo visual.',
    icon: 'mdi-image-multiple',
    image: '/imgs/sections/Online gallery-bro.svg',
    route: '/gallery'
  },
  {
    name: 'nosotros',
    title: 'Nosotros',
    description: 'Conoce quiénes somos, nuestra historia y cómo hacemos realidad tu boda.',
    icon: 'mdi-account-group',
    image: '/imgs/sections/About us page-pana.svg',
    route: '/nosotros'
  },
  {
    name: 'servicios',
    title: 'Servicios',
    description: 'Descubre los servicios que ofrecemos para bodas únicas e inolvidables.',
    icon: 'mdi-cog-outline',
    image: '/imgs/sections/Data processing-bro.svg',
    route: '/servicios'
  },
  {
    name: 'testimonios',
    title: 'Testimonios',
    description: 'Lee las experiencias de nuestros clientes y cómo vivieron su gran día.',
    icon: 'mdi-comment-quote-outline',
    image: '/imgs/sections/Online Review-bro.svg',
    route: '/testimonios'
  },
  {
    name: 'contacto',
    title: 'Contacto',
    description: 'Ponte en contacto con nosotros para cotizar tu evento o resolver dudas.',
    icon: 'mdi-phone',
    image: '/imgs/sections/Connected-cuate.svg',
    route: '/contacto'
  }
]
</script>

<style scoped>
.v-card-title {
  font-weight: 600;
}
</style>
